import { DeleteOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { DeletedFilled } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFloorsByFloorID } from 'reduxStore/floors/selectors';
import { floorsActions } from 'reduxStore/floors/slice';
import { Button, Divider, Flex, Modal, Tooltip, Typography } from 'zui/Antd';

const { Title, Text } = Typography;

const DeleteFloorModal = ({ children, floorID, open, setOpen }) => {
	// ✅ Hooks
	const {
		token: { paddingLG, fontSizeSM, marginXL, marginXS, paddingXL, paddingXS, paddingSM }
	} = theme.useToken();
	const dispatch = useDispatch();

	// ✅ Redux state
	const { deleteFloorLoading: loading } = useSelector((state) => state.Floors);
	const floor = useSelector((state) => selectFloorsByFloorID(state, floorID));

	//Determine if is permitted to  delete floors
	const isPermittedDeleteFloor = useManagePermittedRoles('deleteFloor', {
		101: [floor?.orgID],
		103: [floor?.siteID],
		104: [floor?.floorID]
	});

	// ✅ Close modal
	const handleCancel = () => setOpen(false);

	// ✅ Handle deletion
	const handleDelete = () => {
		dispatch(floorsActions.deleteFloor({ floorID }));

		setTimeout(() => {
			handleCancel();
		}, 500);
	};

	return (
		<Fragment>
			<Tooltip title={isPermittedDeleteFloor ? 'Delete Floor' : "You don't have permission to delete this floor"}>
				{children ? (
					children
				) : (
					<Button
						icon={<DeleteOutlined />}
						onClick={() => setOpen(true)}
						disabled={!isPermittedDeleteFloor || loading}
						danger
						type='primary'
					>
						Delete Floor
					</Button>
				)}
			</Tooltip>

			<Modal
				open={open}
				onCancel={handleCancel}
				closeIcon={false}
				centered
				destroyOnClose
				footer={[
					<Flex
						align='center'
						justify='center'
						style={{ marginTop: marginXL, padding: `0px ${paddingXS}px` }}
						gap={12}
						key='footer'
					>
						<Button onClick={handleCancel} type='default' disabled={loading} block>
							Cancel
						</Button>
						<Button onClick={handleDelete} loading={loading} disabled={loading} type='primary' danger block>
							Delete
						</Button>
					</Flex>
				]}
				width={350}
				styles={{ content: { padding: paddingXL } }}
			>
				<Flex vertical align='center' justify='center' gap={paddingSM}>
					<DeletedFilled />
					<Flex vertical gap={paddingLG}>
						<Flex vertical gap={paddingXS} align='center' style={{ margin: `${paddingXS}px 0px` }}>
							<Title
								level={5}
								style={{
									margin: 0,
									lineHeight: '24px',
									textAlign: 'center',
									padding: `0px ${paddingXL}px`
								}}
							>
								Are you sure you want to delete this floor?
							</Title>
							<Text
								style={{
									fontSize: fontSizeSM,
									lineHeight: '24px',
									textAlign: 'center',
									display: 'block'
								}}
							>
								This action is permanent and <br /> cannot be undone.
							</Text>
						</Flex>

						<Flex vertical gap={marginXS}>
							<Divider orientation='center' plain style={{ margin: 0, padding: 0, marginTop: 0 }}>
								<Text style={{ fontSize: fontSizeSM, fontWeight: 200 }}>Selected Floor</Text>
							</Divider>
							<Text style={{ fontSize: fontSizeSM, fontWeight: 200, textAlign: 'center' }}>
								{floor?.name || '-'}
							</Text>
						</Flex>
					</Flex>
				</Flex>
			</Modal>
		</Fragment>
	);
};

export default DeleteFloorModal;
